import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import classNames from 'classnames';
import { reportGrossProfitHoverCOGSAdj } from 'clevertap/reports/grossProfit';
import InformationModal from '../InformationModal/InformationModal';
import RenderByScreenSize from '../../RenderByScreenSize';
import styles from './CogsInfoPopover.css';

class CogsInfoPopover extends Component {
  state = {
    // Info modal is only used in mobile mode
    openInfoModal: false,
  };

  showInfoModal = () => {
    this.setState({ openInfoModal: true });
  };

  hideInfoModal = () => {
    this.setState({ openInfoModal: false });
  };

  renderLargeScreen = () => {
    const popover = (
      <Popover id="cogs-info-popover">
        <p className={styles.tooltipMessage}>
          COGS adjustment happens when you create a Purchase Order, Refund or
          have an Incoming Transfer for an item that previously had negative
          inventory.
        </p>
      </Popover>
    );
    return (
      <OverlayTrigger
        trigger={['click', 'hover', 'focus']}
        rootClose
        placement="top"
        overlay={popover}
      >
        <i
          className={classNames('fa fa-exclamation-circle', styles.popoverIcon)}
          onMouseEnter={reportGrossProfitHoverCOGSAdj}
        />
      </OverlayTrigger>
    );
  };

  renderSmallScreen = () => {
    const { openInfoModal } = this.state;

    // TODO Use Fragment in React 16
    return (
      <span>
        <i
          className={classNames('fa fa-exclamation-circle', styles.popoverIcon)}
          onClick={this.showInfoModal}
        />

        {openInfoModal && <InformationModal onClose={this.hideInfoModal} />}
      </span>
    );
  };

  render() {
    return (
      <RenderByScreenSize
        renderLargeScreen={this.renderLargeScreen}
        renderSmallScreen={this.renderSmallScreen}
      />
    );
  }
}

export default CogsInfoPopover;
